import { combineReducers } from 'redux';
import patients from './patient-list';
import auth from './auth';
import session from './session';
import addPatient from './add-patient';
import { actions } from '../constants';

const appReducer = combineReducers({
  patients,
  auth,
  session,
  addPatient
});

const rootReducer = (state, action) => {
  if ( action.type === actions.CLEAR_SESSION ) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js